export const downloadNowButton = 'download-now-title';
export const getStartedButton = 'get-started-button';
export const featuresPricingSubscriptionButton = 'features-pricing-subscription-button';